<div class="sidenav-content">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>datacenter.all-data-center</span>
	</div>
	<div class="datacenter-grid copo-container">
		<section class="datacenter-card" *ngIf="user.hasService('PORDT')">
			<div class="datacenter-card-title" translate>transversal.data-center-order</div>
			<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/order/datacenter'] : ['/order-tracking/order/list']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('order'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/order/datacenter'] : ['/order-tracking/order/list']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PORDT')">
			<div class="datacenter-card-title" translate>transversal.data-center-batches</div>
			<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/batch/datacenter'] : ['/order-tracking/batch/list']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('batch'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/batch/datacenter'] : ['/order-tracking/batch/list']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PDOCS') && (user.hasServiceParameterEqualsTo('PDOCS', 'DispatchAdvice', 'True') || user.hasServiceParameterEqualsTo('PDOCS', 'OrderAcknowledgment', 'True') || user.hasServiceParameterEqualsTo('PDOCS', 'Certificate', 'True') || user.hasServiceParameterEqualsTo('PDOCS', 'Invoice', 'True') || user.hasServiceParameterEqualsTo('PDOCS', 'XCarb', 'True'))">
			<div class="datacenter-card-title" translate>transversal.data-center-documents</div>
			<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/commercial-documents/datacenter'] : ['/commercial-documents/list']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('document'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/commercial-documents/datacenter'] : ['/commercial-documents/list']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasServiceParameterEqualsTo('PORDT', 'SBOrder', 'True')">
			<div class="datacenter-card-title" translate>datacenter.schedule-business-order</div>
			<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/schedule-business-order/datacenter'] : ['/order-tracking/schedule-business-order/list']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('schedule-business-order'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/order-tracking/schedule-business-order/datacenter'] : ['/order-tracking/schedule-business-order/list']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PORDT')">
			<div class="datacenter-card-title" translate>transversal.shipments</div>
			<a class="datacenter-card-item" [routerLink]="['/order-tracking/shipment/datacenter']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('shipment'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="['/order-tracking/shipment/datacenter']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('QUAPP')">
			<div class="datacenter-card-title" translate>issue.qualityissues</div>
			<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/quality-issues/datacenter'] : ['/quality-issues/list']" [state]="{ filter: [] }">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('quality'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="!mediaQuery.matches ? ['/quality-issues/datacenter'] : ['/quality-issues/list']" [state]="{ filter: [], view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('EOFFR')">
			<div class="datacenter-card-title" translate>eoffer.offer.plural</div>
			<a class="datacenter-card-item" [routerLink]="['/offer/datacenter']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('offer'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="['/offer/datacenter']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PORUM')">
			<div class="datacenter-card-title" translate>settings.organizations</div>
			<a class="datacenter-card-item" [routerLink]="['/organizations/organization/datacenter']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('organization'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="['/organizations/organization/datacenter']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PORUM')">
			<div class="datacenter-card-title" translate>transversal.data-center.users</div>
			<a class="datacenter-card-item" [routerLink]="['/users/users/datacenter']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('users'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="['/users/users/datacenter']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>

		<section class="datacenter-card" *ngIf="user.hasService('PFAST')">
			<div class="datacenter-card-title" translate>transversal.data-center.prototype</div>
			<a class="datacenter-card-item" [routerLink]="['/fastlane/prototype/datacenter']">
				<span class="item-label">Default view</span>
				<span class="item-chevron">›</span>
			</a>
			<ng-container *ngFor="let favoriteView of getFavoriteViews('prototypes'); trackBy: trackByViewId">
				<a class="datacenter-card-item" [routerLink]="['/fastlane/prototype/datacenter']" [state]="{ view: favoriteView }">
					<span class="item-label"><mat-icon class="item-favorite" svgIcon="favorite_heart_selected"></mat-icon>{{ favoriteView.name }}</span>
					<span class="item-chevron">›</span>
				</a>
			</ng-container>
		</section>
	</div>
</div>
